function initialState() {
  return {};
}

let state = initialState();

export { initialState, state };
